<template>
  <div class="publications-by-source-content" :id="chartId">
    <div class="hidden-chart-name">
      {{title}} <b>{{charDateTitle}}</b>
    </div>
    <bar-chart
      v-if="isLoaded"
      :chart-data="dataBarCollection"
      :options="barOptions"
      class="publications-by-source-and-gsm-content__chart"
      :height="250"
    ></bar-chart>

    <div class="axes-title">
      {{$t('feed.analytics.bySourceAndGsm.body.axesTitle')}}
    </div>

    <div class="chart-footer">
      <ul class="tonal-list" v-if="Object.keys(dataBarCollection).length">
        <li v-for="(item, index) in tonal" :class="`tonal-list__item tonal-list__item--${item.name}`" :key="index">
          {{item.title}}
        </li>
      </ul>

      <el-checkbox v-model="showZeroData" data-html2canvas-ignore="true">{{$t('feed.analytics.bySourceAndGsm.body.zero')}}</el-checkbox>
    </div>
    <div class="chart-show-labels" data-html2canvas-ignore="true" @click="toggleLabel">
      <el-checkbox :value="showLabel" @change="toggleLabel">{{$t('feed.analytics.bySourceAndGsm.body.captions')}}</el-checkbox>
    </div>
    <a href="" :id="`download${chartId}`"></a>
  </div>
</template>

<script>
  // chart
  import { BarChart } from "../../../../../../../../components/charts";

  // mixins
  import publicationsBySourceAndGsm from "../../../../../../../../mixins/chart/publicationsBySourceAndGsm";
  import saveImage from "../../../../../../../../mixins/saveImage";

  // actions
  import {SWITCH_ZERO} from "../../../../../../../../store/actions/analytics";

  // config
  import tonal from "../../../../../../../../config/tonals";

  // vuex
  import { mapGetters } from "vuex";

  // moment
  import moment from 'moment';

  export default {
    name: "PublicationsBySourceAndGsmBody",
    props: {
      data: {
        type: Object,
        required: true
      },
      saveChart: {
        type: Boolean,
        default: false
      },
      chartName: {
        type: String
      },
      title: {
        type: String
      },
    },
    data() {
      return {
        tonal: this.$t('feed.analytics.bySourceAndGsm.body.tonal'),
        chartId: "PublicationsBySourceAndGsm",
        format: "DD.MM.YYYY",
        showLabel: true,
      }
    },
    methods: {
      toggleLabel () {
        this.showLabel = !this.showLabel;
      },
    },
    computed: {
      ...mapGetters([
        "socialList",
      ]),
      showZeroData: {
        get() {
          return this.$store.getters.getZeroData(this.chartName);
        },
        set(value) {
          this.$store.dispatch(SWITCH_ZERO, {chart: this.chartName, isZero: value})
        }
      },
      chartDate() {
        return this.$store.getters.getPeriod(this.chartName);
      },
      charDateTitle () {
        return `${moment(this.chartDate[0]).format(this.format)} - ${moment(this.chartDate[1]).format(this.format)}`;
      },
      isLoaded() {
        return this.$store.getters.isLoaded(this.chartName);
      }
    },
    mixins: [
      publicationsBySourceAndGsm,
      saveImage
    ],
    components: {
      BarChart
    }
  };
</script>

<style>
@import "../../../../../../../../style/tonal.css";

.publications-by-source-and-gsm-content__chart {
  margin-bottom: 10px;
}

.axes-title {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Roboto", "Arial", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  padding: 0 0 10px 0;
  color: #5E6D82;
}
.chart-show-labels {
  display: flex;
  justify-content: start;
  padding: 20px 10px;
  font-size: 16px;
}
@media screen and (max-width: 480px) {
  .publications-by-source-and-gsm-content__chart {
    width: 90vw;
  }
}
</style>
